/**
 * Grid para a funcionalidade de route suggestion.
 * @author: adalto.junior
 * Date: 20/12/13
 * Time: 15:06
 */


Greenmile.RouteSuggestion = Greenmile.RouteSuggestion || {};
Greenmile.RouteSuggestion.Grid = function () {

    var __entity = 'RouteSuggestion';

    var addPendingOrderToRoute = function (e, args, pendingOrder) {

        var row;
        var grid;
        var dataItem;
        var popup;
        var dataModel;

        row = args.row;
        grid = args.grid;

        dataItem = grid.getDataItem(row);
        dataModel = dataItem.model;

        popup = new Greenmile.RouteSuggestion.PopupAssignToRoute();

        popup.setRoute(dataModel.attributes);
        popup.setPendingOrder(pendingOrder.attributes);
        popup.setPlacement(dataModel.get('placement'));
        popup.setRelatedStopId(dataModel.get('stop'));

        popup.show({
            selector: '#RouteSuggestion',
            scopeBlock: '#RouteSuggestion .grid_list_template',
            width: 500,
            height: 168
        });


    };


    this.show = function (suggestions, pendingOrder) {

        var error,
            options = {
                entity: __entity,
                columnCheckBox: {
                    show: false
                },
                columnEdit: {
                    show: false
                },
                multiSelect: false,
                selecteRows: true
            },
            columns = [],
            addPagination     = false,
            selector          = "#RouteSuggestion #grid",
            selectorToActions = "#RouteSuggestion .gridActions",
            dataProvider,
            layout,
            router,
            secionRelatedList,
            grid;

        try {

            var customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
            var saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();
            var element = document.querySelector(selectorToActions);

            var callbackToActionsToGrid = function (context, suggestions, pendingOrder) {
                return function () {

                    element.innerHTML = '';
                    App.Forms.RouteSuggestion.layout = {};
                    context.show(suggestions, pendingOrder);

                };
            }(this, suggestions, pendingOrder);


            var eventOnclick = function (scope, pendingOrder) {
                return function (e, args) {
                    const grid = args.grid;
                    const row = args.row;
                    const dataItem = grid.getDataItem(row);
                    const dataModel = dataItem.model;

                    const id = dataModel.cid;

                    scope.checkRadioColumn(id);
                    addPendingOrderToRoute(e, args, pendingOrder);
                };

            }(this, pendingOrder);

            customizeColumns.setEntity(__entity);
            customizeColumns.setScreenName(__entity);
            customizeColumns.setSelector(selectorToActions);
            customizeColumns.setElement(element);

            customizeColumns.setCallBacks({
                afterSaveList: callbackToActionsToGrid
            });

            saveGridLayout.setEntity(__entity);
            saveGridLayout.setScreenName(__entity);
            saveGridLayout.setSelector(selectorToActions);
            saveGridLayout.setElement(element);

            saveGridLayout.setCallBacks({
                afterSaveList: callbackToActionsToGrid
            });

            customizeColumns.init();
            saveGridLayout.init();

            router = new App.Routers.RouteSuggestion();
            layout = App.Forms.RouteSuggestion.layout;

            if (!layout) {
                App.Forms.RouteSuggestion.layout = {};
                layout = App.Forms.RouteSuggestion.layout;
            }

            if (!layout.index) {

                router.renderGrid(suggestions, pendingOrder);
                layout = App.Forms.RouteSuggestion.layout;
                return;
            }

            columns.push({
                id: "radio-button",
                entity: __entity,
                field: "radio-button",
                cssClass: "cell-row",
                name: Monet.I18n.getResourcesByKey('RepetitionField.select'),
                width: 68,
                sortable: false,
                resizable: false,
                formatter: (row, cell, value) => {
                    return value;
                }
            });

            this.mapDataToAddRadio(suggestions);

            const sortableColumns = Monet.Grid.getGridLayout(layout.index, __entity);
            sortableColumns.forEach(item => columns.push(item));

            columns = Monet.Grid.Utils.removeSortableOfColumns(columns);

            secionRelatedList = layout.index.sections[0].sectionRelatedLists;
            options.frozenColumn = Monet.Grid.Utils.getIndexColumnFrozen(secionRelatedList);
            
            dataProvider = new Monet.Grid.DataProvider(columns, options, __entity);
            grid = new Monet.Grid.GenericGrid(selector, dataProvider, columns, options);
            
            grid.onClick.unsubscribe(eventOnclick);
            grid.onClick.subscribe(eventOnclick);
            
            App.Forms.RouteSuggestion.table = grid;
            App.Forms.RouteSuggestion.dataProvider = dataProvider;
            
            Monet.Grid.addDataToGrid(__entity, columns, suggestions, addPagination);

        } catch (e) {

            error = new Monet.Exception.ReturnError(
                this, 'Error on show route suggestion grid', e);
            error.console();

        }

    };

    this.mapDataToAddRadio = function (suggestionsCollection) {
        suggestionsCollection.models.forEach(suggestion => {
            const id = suggestion.cid;

            suggestion.set({
                'radio-button': this.renderRadioButton(id)
            });
        });
    };

    this.checkRadioColumn = function (routeSuggestionId) {
        document
            .querySelector(`#RouteSuggestion .radio-container-${routeSuggestionId} > div > input`)
            .checked = true;
    };

    this.renderRadioButton = function (routeSuggestionId) {
        const radioButton = new Monet.UI.Fields.Radio();
        radioButton.rootEl.setAttribute('class', 'radio-container-child');
        radioButton.render();
        
        const container = document.createElement('div');
        container.appendChild(radioButton.rootEl);
        container.querySelector('input').setAttribute('name', 'routeSuggestionRadio');
        container.className = `radio-container-${routeSuggestionId}`;

        return container.outerHTML;
    };

};
